import {
  PageTemplateTypes,
  PageWorkflowStatus
} from 'shared/types/global'

export enum PageTypes {
  coverFront = 'coverFront',
  coverBack = 'coverBack',
  content = 'content'
}

export type DndPageContentData = {
  templateType: PageTemplateTypes
  name: string
  number: number
  workflowStatus: PageWorkflowStatus
}

export type DndPage = {
  id: string
  type: PageTypes
  index: number
  contentData: DndPageContentData | null // null for cover pages
}
